import { render, staticRenderFns } from "./chuliwancheng.vue?vue&type=template&id=af0d3dc4&"
import script from "./chuliwancheng.vue?vue&type=script&lang=js&"
export * from "./chuliwancheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports